import React from 'react'

import { useTheme } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import HighlightSearch from '../../../../atoms/display/highlightSearch'
import Typography from '../../../../atoms/display/typography'
import IconButton from '../../../../atoms/inputs/iconButton'

import useStyles from '../style'

import { useSnackbar } from 'notistack'

import { setFile } from '../../../../../redux/faq/actions'

import {
  FileCopyRounded as FileIcon,
  AttachmentRounded as AttachmentIcon,
} from '@material-ui/icons'

function FaqsContentItem({ key, faq, ...props }) {
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const activeConversation = useSelector((state) => state.activeConversation)
  const keyword = useSelector(
    (state) => state.faq?.keyword?.[activeConversation]
  )

  const copyToClippboard = (string) => {
    navigator.clipboard.writeText(string).then(
      () => {
        enqueueSnackbar(`${t('commons.copied')}`, {
          variant: 'success',
        })
      },
      (err) => {
        console.error(t('commons.copiedError'), err)
      }
    )
  }

  return (
    <div
      key={key}
      className={classes.faqContainer + ' search-anchor-tree'}
      onClick={(e) => {
        e.stopPropagation()
        if (faq.files) {
          dispatch(
            setFile({
              files: faq.files,
              message: faq.text,
            })
          )
        } else {
          const fieldMessage = document.getElementById(
            `field-message-${activeConversation}`
          )
          if (fieldMessage) {
            fieldMessage.value = faq.text
            fieldMessage.focus()
            fieldMessage.scrollIntoView({
              inline: 'center',
              behavior: 'smooth',
            })
          }
        }
      }}
    >
      <div className={classes.faqContent}>
        <div
          style={{
            width: '100%',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" className={classes.faqTitle}>
              <HighlightSearch
                text={faq.title}
                keyword={keyword}
                anchor="faq"
                copy={false}
              />
            </Typography>
            <div className={classes.pill}>
              {faq.global ? t('faqs.global') : t('faqs.skill')}
            </div>
          </div>
          <Typography variant="body1" className={classes.descriptionText}>
            <HighlightSearch
              text={faq.text}
              keyword={keyword}
              anchor="faq"
              copy={false}
            />
          </Typography>
        </div>
        <div style={{ width: 10 }} />
        <div className={classes.contentIcons}>
          <IconButton
            color="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              copyToClippboard(faq.text)
            }}
          >
            <FileIcon
              style={{
                color: theme.palette.primary.main,
                fontSize: 14,
                margin: 3,
              }}
            />
          </IconButton>
          {faq.files && (
            <IconButton
              color="primary"
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                window.open(faq.files)
              }}
            >
              <AttachmentIcon />
            </IconButton>
          )}
        </div>
      </div>
    </div>
  )
}

export default FaqsContentItem
